import { render, staticRenderFns } from "./ModalUnlink.vue?vue&type=template&id=490fede8&"
import script from "./ModalUnlink.vue?vue&type=script&lang=js&"
export * from "./ModalUnlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports